const attributes = [
    {
        isHeader: true,
        name: 'businessRequestItemFriendlyName',
        sortable: true,
        sortBy: 'BusinessRequestItemFriendlyName',
        label: 'Name',
        headerCellStyles: {
            width: '25%',
            minWidth: '180px',
        },
        styles: {
            color: '#9230c5',
            fontSize: '16px',
            fontWeight: 'bold',
            marginTop: '6px',
            marginLeft: '10px',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        link: false,
    },
    {
        name: 'businessRequestName',
        label: 'BusinessRequestName',
        sortBy: 'businessRequestName',
        avatar: false,
        sortable: true,
        styles: {
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'businessRequestNumber',
        label: 'BusinessRequestNumber',
        sortBy: 'businessRequestNumber',
        avatar: false,
        sortable: true,
        styles: {
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'stepStatus',
        hideValue: true,
        label: 'StepStatus',
        sortable: true,
        sortBy: 'StepStatus',

        headerCellStyles: {
            width: '15%',
            minWidth: '15%',
        },
        styles: {
            padding: '20px 0px',
        },
        component: {
            componentName: 'StatusIndicator',
            name: 'stepStatus',
            props: {
                size: 'medium',
            },
        },
    },
    {
        name: 'itemStatus',
        hideValue: true,
        label: 'ItemStatus',
        sortable: true,
        sortBy: 'ItemStatus',

        headerCellStyles: {
            width: '15%',
            minWidth: '15%',
        },
        styles: {
            padding: '20px 0px',
        },
        component: {
            componentName: 'StatusIndicator',
            name: 'itemStatus',
            props: {
                size: 'medium',
            },
        },
    },
    {
        name: 'approverPerson',
        label: 'Approver',
        hideValue: true,
        sortable: true,
        sortBy: 'approverPerson',
        avatar: true,
        imgProp: 'approverPersonURL',
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
        },
        textStyles: {
            color: '#282828',
            fontSize: '13px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
        },
    },
    {
        name: 'approvalFlowDecision',
        label: 'ApprovalDecision',
        sortBy: 'approvalFlowDecision',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'approverComments',
        label: 'ApproverComments',
        sortBy: 'approverComments',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'participantType',
        label: 'ParticipantType',
        sortBy: 'participantType',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'itemTypeAction',
        label: 'ItemTypeAction',
        sortBy: 'itemTypeAction',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'riskViolation',
        label: 'RiskViolation',
        sortBy: 'riskViolation',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        name: 'riskType',
        label: 'RiskType',
        sortBy: 'riskType',
        avatar: false,
        sortable: true,
        headerCellStyles: {
            maxWidth: '150px',
        },
        styles: {
            maxWidth: '150px',
            marginTop: '6px',
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
]

export default attributes
